<sm-title-bar
  [headerCustomTemplate]="addButton"
  pageTitle="Fitness data"
  [back]="true"
>
  <ng-template #addButton>
    <div class="d-flex search-field">
      <div class="create_btn_sd">
        <button mat-button color="accent" (click)="addtrackingitem()">
          <mat-icon>add</mat-icon>
          Add fitness data
        </button>
      </div>
    </div>
  </ng-template>
</sm-title-bar>
<!-- tracking-card.component.html -->
<div class="row" *ngIf="!loader && progressTrackersData.length > 0">
  <div class="col-sm-4" *ngFor="let item of progressTrackersData">
    <mat-card class="custom-tracking" (click)="opentrackdetails(item)">
      <div class="graph_imgx" *ngIf="item.tracking_enabled == 0">
        <img src="../../../../../../../assets/images/fitness-03.png" alt="" />
      </div>
      <div class="graph_imgx" *ngIf="item.tracking_enabled == 1" (click)="$event.stopPropagation()">
        <img
          src="../../../../../../../assets/images/fitness-01.jpeg"
          alt=""
          *ngIf="!item.tracking_logs"
        />
        <!-- <img src="../../../../assets/images/chart-1.png"  alt=""/> -->
        <sm-line-chart-for-trackers
          *ngIf="item.tracking_logs"
          [dataSource]="item.graphData"
        ></sm-line-chart-for-trackers>
      </div>
      <mat-card-content class="mat_ccontent">
        <div style="display: flex;align-items: center;">
          <h3>{{ item.tracking_item_name | titlecase }}</h3>
          <button
            (click)="$event.stopPropagation()"
            *ngIf="item.tracking_enabled == 0"
            class="ms-auto option-btn"
            mat-icon-button
            aria-label="option menu"
            [matMenuTriggerFor]="menu"
          >
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button (click)="deleteItem(item)" mat-menu-item [disabled]="item.creator_type != 2 || item.created_by != employeeHash">
              <mat-icon class="material-icons-outlined">delete</mat-icon>
              <span>Delete</span>
            </button>           
          </mat-menu>
        </div>
        <div *ngIf="item.tracking_enabled == 1">
          <p class="primary-text" *ngIf="item.tracking_logs">
            {{ item.sortedLogs[0].tracking_item_value }}
            {{ item.measurement_unit
            }}<span class="spn_sub" *ngIf="item.tracking_logs">{{
              item.sortedLogs[0].creation_time | date
            }}</span>
          </p>
          <p class="primary-text" *ngIf="!item.tracking_logs">---</p>
        </div>
        <div *ngIf="item.tracking_enabled == 0">
          <p class="primary-text" *ngIf="item.item_current_value">
            {{ item.item_current_value }} {{ item.measurement_unit }}
            <!-- <span class="spn_sub" *ngIf="item.item_current_value">{{item.creation_time | date}}</span> -->
          </p>
          <p class="primary-text" *ngIf="!item.item_current_value">---</p>
        </div>
        <div class="flot_fix" *ngIf="item.tracking_enabled == 1">
          <mat-icon>arrow_forward</mat-icon>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>

<!-- Placeholder start -->
 <!--  -->
 <div class="placeholder_started" *ngIf="!loader && progressTrackersData.length == 0">
        <div class="row">
          <div class="col-sm-4">
            <div class="dashboard_new">
              <mat-card>
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/fitness-1.png">
                 </div>
                 <mat-card-title>No fitness data as of yet.</mat-card-title>
                 <mat-card-content>The member hasn't started tracking anything or set any fitness goal yet. You can add one for him/her.
                </mat-card-content>
                 <div class="create_btnyh">
                    <button mat-flat-button color="primary" (click)="addtrackingitem()">
                        <mat-icon>add</mat-icon> 
                        Add fitness data
                    </button>
                 </div>
                 </div>
              </mat-card>
           </div>
          </div>
          <div class="col-sm-4">
            <div class="dashboard_new">
              <mat-card>
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/tracking-progress.png">
                 </div>
                 <mat-card-title>Why tracking progress?</mat-card-title>
                 <mat-card-content>It's a fundamental tool that transforms the gym experience from a random activity into a strategic, results-driven journey. It is essential for both the member's success and the gym's ability to retain them.
 
                </mat-card-content>
                 <!-- <div class="watch_vc_btn">
                    <button mat-stroked-button color="primary">
                       <mat-icon>support_agent</mat-icon>
                       Contact support 
                    </button>
                 </div> -->
          </div>
        </mat-card>
      </div>
    </div>
  </div>
</div>
<!-- Placeholder end -->
